export default class ExtraIngredient {
    constructor(id) {
        this.name = '';
        this.localizedNames = [];
        this.prices = [];
        this.selected = false;
        this.id = id;
    }
}
